import useCollection from "areas/collection/hoc/use-collection"

import DescriptionAccordion from "./description-accordion"
import FAQ from "./faq"
import Description from "./heading/description"

const CollectionDescription = () => {
  const {
    data: {
      description,
      description_type: descriptionType,
      faqs,
      subtitle,
    } = {},
  } = useCollection()

  if (!description && !faqs?.length && !subtitle) return null

  return (
    <div className="bg-subpolar text-neutral py-24">
      <div className="contained px-16">
        {description && (
          <>
            {["markdown", "spreadsheet"].includes(descriptionType) ? (
              <DescriptionAccordion>{description}</DescriptionAccordion>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: description }} />
            )}
          </>
        )}
        {faqs?.length > 0 && <FAQ faqs={faqs} />}
        {subtitle && (
          <div className="mb-24">
            <Description />
          </div>
        )}
      </div>
    </div>
  )
}

export default CollectionDescription
